import firebase from "datastore/database";
import store from "datastore/store";

export default function observeTransactions(businessUid) {
  store.dispatch({ type: "ADD_TRANSACTIONS_LOADING" });
  return firebase
    .firestore()
    .collection(`transaction-log/business/${businessUid}`)
    .onSnapshot((snap) => {
      const transaction = snap.docs.map((doc) => ({
        uid: doc.id,
        ...doc.data(),
      }));
      store.dispatch({ type: "ADD_TRANSACTIONS_SUCCESS", transaction });
    });
}
